import React from "react";
import { content } from "../../Context/translate";
import { IoMdStar } from "../../Context/exportIcons";

const NavBarProUsers = ({ data, title, desc }) => {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-3 mb-2">
        <IoMdStar className="text-yellow-500 text-2xl" />
        <h1 className="text-2xl font-bold text-gray-800">
          {content.proUsers}
        </h1>
      </div>
      <p className="text-gray-600 mb-4">
        {desc}
      </p>
      {/* {data?.total && (
        <div className="bg-gradient-to-r from-yellow-100 to-pink-100 p-3 rounded-lg">
          <p className="text-gray-700 font-medium">
            إجمالي الأعضاء المميزين: {data.total}
          </p>
        </div>
      )} */}
    </div>
  );
};

export default NavBarProUsers; 